import React from 'react'
import { ALL_AOLS, AOL_DISPLAY_NAMES } from 'constants/aol/aol'
import { PRIMARY_AOL } from 'constants/requests'
import { updatePrimaryAol } from 'services/SessionService'
import Icon from 'components/shared/Icon'
import ControlButtons from './ControlButtons'
import { Grid } from '@mui/material'
import InfoToolTipIcon from './InfoToolTipIcon'
import { useAolUpdate } from 'hooks/useAolUpdate'
import { AOL_TOOLTIP_TEXT } from 'helpers/aol/aolTooltipText'

interface PrimaryAolSelectorProps {
  primaryAol: string
  onAolChange?: (newAol: string) => void
}

const PrimaryAolSelector: React.FC<PrimaryAolSelectorProps> = ({
  primaryAol,
  onAolChange
}) => {
  const { selectedAol, changed, handleChange: handleAolChange, handleSave, handleCancel } = useAolUpdate({
    currentValue: primaryAol,
    updateFunction: updatePrimaryAol,
    refreshRequest: PRIMARY_AOL,
    successMessage: 'Primary practice area saved'
  })

  const handleChange = (aol: string): void => {
    handleAolChange(aol)
    if (onAolChange !== undefined) onAolChange(aol)
  }

  return (
    <div className='h5 mb10'>
      <Grid container className='flex items-center'>
        <Grid item className='mr2'>
          <InfoToolTipIcon
            title={AOL_TOOLTIP_TEXT.primary}
          />
        </Grid>
        <h3>Primary Area of Law</h3>
      </Grid>
      <div role='radiogroup' className='flex'>
        {ALL_AOLS.map((aol: string) => {
          const checked = selectedAol === aol
          return (
            <label
              key={aol}
              htmlFor={`primaryAol-${aol}`}
              className={`mr6 mb0 lighter flex items-center account-input-label pointer${
                checked ? ' account-input-checked' : ''
              }`}
            >
              <Icon
                className='mr2 w7'
                name={
                  checked
                    ? 'icon-checkbox-marked-circle-outline'
                    : 'icon-checkbox-blank-circle-outline'
                }
              />
              <input
                className='dn'
                type='radio'
                id={`primaryAol-${aol}`}
                name='primaryAol'
                value={aol}
                checked={checked}
                onChange={() => handleChange(aol)}
                data-event-category='Primary AOL'
                data-event-action='Select'
                data-event-label={aol}
              />
              <span className={checked ? 'teal' : ''}>
                {AOL_DISPLAY_NAMES[aol as keyof typeof AOL_DISPLAY_NAMES] !== ''
                  ? AOL_DISPLAY_NAMES[aol as keyof typeof AOL_DISPLAY_NAMES]
                  : aol}
              </span>
            </label>
          )
        })}
      </div>
      <ControlButtons
        changed={changed}
        handleSave={handleSave}
        handleCancel={handleCancel}
      />
    </div>
  )
}

export default PrimaryAolSelector
